import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    q: "How do photographers get more bookings in Colorado?",
    a: "Niche-specific landing pages. 'Wedding photographer', 'newborn photographer', 'family photos Garden of the Gods', and 'headshot photographer' are completely different searches. Photographers who build one 'portfolio' page are invisible — the ones with niche pages book year-round.",
  },
  {
    q: "Is SEO worth it for a wedding photographer?",
    a: "Absolutely. Wedding searches happen 6–18 months out, and SEO is the cheapest way to be in front of brides researching. One booked wedding ($3K–$8K) pays back the engagement many times over.",
  },
  {
    q: "What about portraits, headshots, and commercial work?",
    a: "Each is a separate page with different intent. Commercial/branding photography for businesses converts at a much higher margin and is under-marketed by most Colorado photographers — we focus there heavily.",
  },
  {
    q: "Should I run Google Ads for photography?",
    a: "Only for seasonal pushes (mini-sessions, fall family photos, holiday cards). Outside those windows, lean on SEO, Instagram, and referrals.",
  },
  {
    q: "Do I really need a custom site, or is Pixieset/Squarespace enough?",
    a: "Template sites rank fine for your name but rarely for niche searches. If you want inbound bookings from 'Colorado Springs family photographer', you need real content, fast pages, and proper schema — which template builders rarely deliver.",
  },
];

export const Route = createFileRoute("/photographer-marketing-colorado")({
  head: () =>
    industryMarketingHead("Photographer", "photographer", "photographer-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry="Photographer"
      industryLower="photographer"
      slug="photographer-marketing-colorado"
      subheadline="We help Colorado photographers book year-round — weddings, families, headshots, commercial — by turning a beautiful portfolio into a search-ranked client engine."
      painPoints={[
        "Your portfolio is gorgeous but invisible on Google",
        "Wedding inquiries dropped because brides find chain photographers first",
        "Commercial and branding work — the highest-margin gigs — never come inbound",
      ]}
      serviceDescriptions={{
        seo: "Rank for wedding, family, newborn, headshot, and commercial photography across every Colorado market.",
        googleMaps: "Own 'photographer near me' in the Map Pack so last-minute bookings come to you.",
        webDesign: "Fast, image-heavy portfolio sites that load instantly and rank — not slow template builds.",
        ppc: "Seasonal Google Ads for mini-sessions, fall family photos, and holiday-card surges.",
        geoAi: "Get cited when buyers ask ChatGPT 'best wedding photographer in Colorado Springs' or 'family photos near me'.",
        socialMedia: "Instagram-to-site flows that convert followers into booked sessions.",
      }}
      testimonial={{
        quote:
          "My fall family booked solid in three weeks. The site finally ranks for the searches my couples actually use.",
        role: "Wedding & Family Photographer",
        city: "Colorado Springs",
      }}
      faqs={FAQS}
      cityHubLinks={[
        { to: "/colorado-springs", label: "Photographer marketing in Colorado Springs", description: "Wedding, family, and commercial work across the Pikes Peak region." },
        { to: "/denver-digital-marketing", label: "Photographer marketing in Denver", description: "Compete for high-end wedding and commercial work across the Denver metro." },
        { to: "/boulder-digital-marketing", label: "Photographer marketing in Boulder", description: "Mountain weddings, lifestyle families, and tech-startup branding in Boulder." },
      ]}
    />
  ),
});
